import { KEYS } from 'app/constants/SceneConstants';
import { CUTSCENES } from '../constants/Constants';
import SceneBaseTT from './SceneBaseTT';
import { AssetUnloader } from '@jollywise/jollygoodgame';

const CUTSCENE_PAUSE = 4000;

export default class CutScene extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.CutScene, active: false });
  }

  init(config) {
    this._data = config.data;
    this._cutsceneConfig = CUTSCENES[this._data.type];
  }

  preload() {
    this.game.hud.setState('EMPTY');
    this._pack = {
      cutscene: {
        path: 'assets/spine',
        files: [
          {
            type: 'spine',
            key: this._cutsceneConfig.spineid,
            jsonURL: this._cutsceneConfig.spineid + '.json',
            atlasURL: this._cutsceneConfig.spineid + '.atlas',
          },
        ],
      },
    };
    this.load.addPack(this._pack, 'cutscene');
  }

  create() {
    super.create();

    this.setBackgroundImage('background_load');
    this.game.hud.setState('CUTSCENE');
    this.game.hud.events.on('btn_skip', this.handleSkip, this);
    this.activeStage = -1;

    if (this._data.type) {
      this.spine = this.add.spine(840, 360, this._cutsceneConfig.spineid);
      this.spine.once('complete', this.handleSceneComplete, this);
      this.spine.on('event', this.handleEvent, this);
      this.spine.play(this._cutsceneConfig.animation);
    }

    this.copyPanel = this.add.rectangle(0, 720, 1680, 160, 0x000000, 0.75).setOrigin(0, 1);
    this.copyPanel.alpha = 0;
    this.copy = this.add.image(840, 640, 'locale_text');
    this.copy.scale = 0;

    const animation = this.spine.findAnimation('animation');
    const eventTimeline = animation.timelines.find((a) => a.events);
    this.input.keyboard.on('keydown-SPACE', this.handleSkip, this);
    this.stateIndex = 0;
    this.timestamps = eventTimeline.events.map((e) => e.time);
  }

  handleEvent(a, event) {
    if (event.data.name == 'nextstage') {
      this.activeStage++;
      this.spine.timeScale = 0;

      this.showCopy(this._cutsceneConfig.copyPrefix + (this.activeStage + 1));
      this.startPauseTimer();
    }
  }

  handleSkip() {
    if (this.stateIndex >= this.timestamps.length - 1) {
      this.handleSceneComplete();
    } else {
      this.spine.state.tracks[0].trackTime = this.timestamps[this.stateIndex + 1];
      this.clearPauseTimer();
      this.continue();
    }
  }

  continue() {
    this.stateIndex++;
    this.hideCopy();
    this.spine.timeScale = 1;
  }

  handleSceneComplete() {
    if (this._data.onComplete) this._data.onComplete.apply(this.data.onCompleteScope);
  }

  showCopy(frame) {
    this.tweens.killTweensOf(this.copy);
    this.copy.setFrame(frame);
    this.copy.visible = true;
    this.copy.scale = 1;
    this.tweens.add({
      targets: this.copy,
      duration: 150,
      scale: 1.3,
      yoyo: true,
    });
    this.copyPanel.alpha = 0;
    this.tweens.add({
      targets: this.copyPanel,
      alpha: 1,
      duration: 150,
    });
  }

  hideCopy() {
    this.tweens.killTweensOf(this.copy);
    this.copy.visible = true;
    this.tweens.add({
      targets: this.copy,
      duration: 150,
      scale: 0,
    });
    this.tweens.add({
      targets: this.copyPanel,
      alpha: 0,
      duration: 150,
    });
  }

  startPauseTimer() {
    this.timeout = this.time.addEvent({
      delay: CUTSCENE_PAUSE,
      callback: this.continue,
      callbackScope: this,
    });
  }

  clearPauseTimer() {
    if (this.timeout) {
      this.timeout.destroy();
      this.timeout = null;
    }
  }

  shutdown() {
    this.clearPauseTimer();
    if (this._pack) {
      AssetUnloader.UnloadAssetpack(this, this._pack);
      this._pack = null;
    }
    this.spine = null;
    this.copy = null;
    this.game.hud.events.off('btn_skip', this.handleSceneComplete, this);
    super.shutdown();
  }
}
